{
  "records": {
    "Opportunity": [
      {
        "Id": "006Qz0000c2d0b8AAA",
        "External_ID__c": "Opportunity_3f6c1d52-8a47-4e0b-9b1e-5c7a2d94e610",
        "Customer_ID__c": "VR23200808",
        "Deposit_Deposit__c": 65000,
        "interested_in_conveyancing__c": false,
        "Current_Property_Status__c": "Listed for sale",
        "Current_Property_Offer_Status__c": "Accepted offer",
        "Sale_price__c": 285000,
        "Mortgage_on_current_property__c": "Yes"
      }
    ],
    "Deposit_source__c": [
      {
        "Id": "a0DQz000017abb7AAA",
        "External_ID__c": "DepositSource_3f6c1d52-8a47-4e0b-9b1e-5c7a2d94e610_Saleofproperty",
        "Opportunity__c": "006Qz0000c2d0b8AAA",
        "Deposit_source_type__c": "Sale of property",
        "Deposit_amount__c": 55000,
        "Deposit_location__c": "UK Bank Account"
      },
      {
        "Id": "a0DQz0000816cc8AAA",
        "External_ID__c": "DepositSource_3f6c1d52-8a47-4e0b-9b1e-5c7a2d94e610_Savings",
        "Opportunity__c": "006Qz0000c2d0b8AAA",
        "Deposit_source_type__c": "Savings",
        "Deposit_amount__c": 10000,
        "Deposit_location__c": "UK Bank Account"
      }
    ],
    "Applicant__c": [
      {
        "Id": "a0AQz0000a25bf6AAA",
        "External_ID__c": "Applicant_b7e2c1a4-5d3f-4f60-9a8e-1c0d2e3f4a5b",
        "Marital_Status1_Applicant__c": "Single",
        "Occupancy_status__c": "Owner",
        "Relationship_to_second_applicant__c": null
      }
    ],
    "Dependants__c": [
      {
        "Id": "a0BQz0000944f83AAA",
        "External_ID__c": "Dependants_b7e2c1a4-5d3f-4f60-9a8e-1c0d2e3f4a5b_0",
        "Applicant__c": "a0AQz0000a25bf6AAA",
        "Lead_applicant__c": "a0AQz0000a25bf6AAA",
        "Second_applicant__c": null,
        "Name": "Dependent 1",
        "Age__c": 6,
        "Age_period__c": "Years",
        "Relationship__c": "Child"
      },
      {
        "Id": "a0BQz0000279294AAA",
        "External_ID__c": "Dependants_b7e2c1a4-5d3f-4f60-9a8e-1c0d2e3f4a5b_1",
        "Applicant__c": "a0AQz0000a25bf6AAA",
        "Lead_applicant__c": "a0AQz0000a25bf6AAA",
        "Second_applicant__c": null,
        "Name": "Dependent 2",
        "Age__c": 18,
        "Age_period__c": "Months",
        "Relationship__c": "Child"
      }
    ],
    "Expenditure__c": [
      {
        "Id": "a0CQz0000616b17AAA",
        "External_ID__c": "Expenditure__c_3f6c1d52-8a47-4e0b-9b1e-5c7a2d94e610",
        "Applicant__c": "a0AQz0000a25bf6AAA",
        "Childcare__c": 420,
        "Childcare_2__c": "Monthly",
        "Child_Maintanence_Payments__c": 0,
        "Child_Maintenance_Payments_2__c": "Monthly"
      }
    ],
    "Income_Employment__c": [
      {
        "Id": "a0EQz0000125b2cAAA",
        "External_ID__c": "IncomeEmployment_b7e2c1a4-5d3f-4f60-9a8e-1c0d2e3f4a5b",
        "Applicant__c": "a0AQz0000a25bf6AAA",
        "Job_Title__c": "Software Engineer",
        "Income_Changes_2_Years__c": "Stay about the same",
        "Employer_Name__c": "Brightwell Analytics Ltd",
        "On_Probation__c": "No",
        "st_nametradedunder__c": null,
        "director_companyname__c": null,
        "llp_name__c": null
      }
    ],
    "Property__c": [
      {
        "Id": "a0PQz000068ca36AAA",
        "External_ID__c": "Property_VR23200808",
        "Opportunity__c": "006Qz0000c2d0b8AAA",
        "Source__c": "Online",
        "Postcode__c": "BS6 7QR",
        "FirstLineOfAddress__c": "14, Cotham Road",
        "Town__c": "Bristol",
        "Region__c": "South West",
        "Country__c": "England",
        "YearBuilt__c": 1934,
        "Tenure__c": "Freehold",
        "TenureLeaseRemaining__c": null,
        "IsServiceCharge__c": false,
        "ServiceChargeAmount__c": null,
        "GroundRentAmount__c": null,
        "IsStandardConstruction__c": true,
        "ConstructionType__c": "Brick",
        "RoofType__c": "Pitched Tiled",
        "PropertyType__c": "House",
        "HouseOrFlatType__c": "Semi-Detached House",
        "FlatType__c": null,
        "IsNewBuild__c": false,
        "IsPropertyOverTenYears__c": true,
        "IsSelfBuildProject__c": false,
        "NumberOfFloorsInBuilding__c": null,
        "WhatFloorIsFlatOn__c": null,
        "IsTopFloor__c": null,
        "IsExLocalAuthority__c": false,
        "Bedrooms__c": 3,
        "Kitchens__c": 1,
        "HasMoreThanOneKitchen__c": false,
        "ReceptionRooms__c": 2,
        "EpcRating__c": "D",
        "HasValidEpc__c": true,
        "CouncilTaxBand__c": "D",
        "CouncilTaxPaymentFrequency__c": "Monthly",
        "CouncilTaxCost__c": 192
      }
    ],
    "PropertyFlag__c": [
      {
        "Id": "a0FQz0000405c9cAAA",
        "External_ID__c": "PropertyFlag_VR23200808_LargePlot",
        "Property__c": "a0PQz000068ca36AAA",
        "FlagKey__c": "LargePlot",
        "Source__c": "Online",
        "IsActive__c": true
      },
      {
        "Id": "a0FQz00007cea42AAA",
        "External_ID__c": "PropertyFlag_VR23200808_AirbnbProperty",
        "Property__c": "a0PQz000068ca36AAA",
        "FlagKey__c": "AirbnbProperty",
        "Source__c": "Online",
        "IsActive__c": false
      }
    ],
    "PropertyFieldConfirmation__c": [
      {
        "Id": "a0GQz000056356cAAA",
        "External_ID__c": "PropertyFieldConfirmation_VR23200808_YearBuilt__c",
        "Property__c": "a0PQz000068ca36AAA",
        "FieldApiName__c": "YearBuilt__c",
        "ConfirmationStatus__c": "ConfirmedByCustomerViaStreetDataApi"
      },
      {
        "Id": "a0GQz0000687053AAA",
        "External_ID__c": "PropertyFieldConfirmation_VR23200808_Tenure__c",
        "Property__c": "a0PQz000068ca36AAA",
        "FieldApiName__c": "Tenure__c",
        "ConfirmationStatus__c": "ConfirmedByCustomerViaStreetDataApi"
      },
      {
        "Id": "a0GQz0000d7a017AAA",
        "External_ID__c": "PropertyFieldConfirmation_VR23200808_IsServiceCharge__c",
        "Property__c": "a0PQz000068ca36AAA",
        "FieldApiName__c": "IsServiceCharge__c",
        "ConfirmationStatus__c": "ConfirmedByCustomerViaStreetDataApi"
      },
      {
        "Id": "a0GQz000070af5eAAA",
        "External_ID__c": "PropertyFieldConfirmation_VR23200808_IsStandardConstruction__c",
        "Property__c": "a0PQz000068ca36AAA",
        "FieldApiName__c": "IsStandardConstruction__c",
        "ConfirmationStatus__c": "ConfirmedByCustomerViaStreetDataApi"
      },
      {
        "Id": "a0GQz000025ee77AAA",
        "External_ID__c": "PropertyFieldConfirmation_VR23200808_RoofType__c",
        "Property__c": "a0PQz000068ca36AAA",
        "FieldApiName__c": "RoofType__c",
        "ConfirmationStatus__c": "ConfirmedByCustomerViaStreetDataApi"
      },
      {
        "Id": "a0GQz00001f5dcfAAA",
        "External_ID__c": "PropertyFieldConfirmation_VR23200808_Bedrooms__c",
        "Property__c": "a0PQz000068ca36AAA",
        "FieldApiName__c": "Bedrooms__c",
        "ConfirmationStatus__c": "ConfirmedByCustomerViaStreetDataApi"
      },
      {
        "Id": "a0GQz0000180b7aAAA",
        "External_ID__c": "PropertyFieldConfirmation_VR23200808_Kitchens__c",
        "Property__c": "a0PQz000068ca36AAA",
        "FieldApiName__c": "Kitchens__c",
        "ConfirmationStatus__c": "ConfirmedByCustomerViaStreetDataApi"
      },
      {
        "Id": "a0GQz000076e7b3AAA",
        "External_ID__c": "PropertyFieldConfirmation_VR23200808_ReceptionRooms__c",
        "Property__c": "a0PQz000068ca36AAA",
        "FieldApiName__c": "ReceptionRooms__c",
        "ConfirmationStatus__c": "ConfirmedByCustomerViaStreetDataApi"
      }
    ]
  },
  "failed": []
}
